import { Layout } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import Footer from '~/pages/authentified/Footer';
import Header from '~/pages/authentified/Header';
import NavBar from '~/pages/authentified/NavBar';

const { Content } = Layout;

type IProps = {
  children: ReactNode;
};

function ConnectedLayout({ children }: IProps) {
  return (
    <>
      <Layout style={{ minHeight: '100%', width: 'auto' }}>
        <NavBar />
        <Layout>
          <SContent>
            <Header />
            {children}
          </SContent>
          <Footer />
        </Layout>
      </Layout>
    </>
  );
}

export default ConnectedLayout;

const SContent = styled(Content)`
  padding: 2%;
`;
